// bootstrap-datepicker registers $.fn.datepicker on jQuery — required by the
// `.input-daterange` filter init below. Pre-round-2 master shipped neither
// the JS nor the CSS, so the date filter on /winemaking quietly threw
// "$(...).datepicker is not a function" on every page load. Bundling the
// plugin into this same per-page entry keeps the cost on /winemaking only;
// `filters.min.css` (loaded from group_redesign.blade.php) already covers
// the dropdown styles via ticket 02.
require('bootstrap-datepicker');

document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('threads-container');
    if (!container) return;

    const groupSlug = document.getElementById('group-page').dataset.slug;
    const loadingSpinner = document.getElementById('loading-spinner');
    const endOfResults = document.getElementById('end-of-results');
    // The scroll sentinel is now a server-rendered rel="next" anchor (crawlable
    // / no-JS fallback). We intercept it and repoint its href after each batch.
    const sentinelWrap = document.getElementById('next-page-wrap');
    const sentinel = document.getElementById('scroll-sentinel');

    let page = 2;
    let loading = false;
    let hasMore = true;
    let filters = {
        keyword: '',
        author: '',
        date_start: '',
        date_end: '',
        sort: 'latest'
    };

    // Initialize Datepicker
    $('.input-daterange').datepicker({
        format: 'yyyy-mm-dd',
        clearBtn: true,
        autoclose: true,
        toggleActive: true,
        container: 'body'
    }).on('changeDate', function (e) {
        filters.date_start = $('#filter-date-start').val();
        filters.date_end = $('#filter-date-end').val();
        $('#filter-quick-date').val(''); // Clear quick date selection
        fetchThreads(true);
    });

    // Debounce function
    function debounce(func, wait) {
        let timeout;
        return function () {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    // Fetch threads
    function fetchThreads(reset = false) {
        if (loading || (!hasMore && !reset)) return;

        loading = true;
        loadingSpinner.style.display = 'block';
        container.setAttribute('aria-busy', 'true');
        if (reset) {
            container.innerHTML = '';
            page = 1;
            hasMore = true;
            endOfResults.style.display = 'none';
        }

        const params = new URLSearchParams({
            page: page,
            ...filters
        });

        // Update URL
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({ path: newUrl }, '', newUrl);

        fetch(`${window.location.pathname}?${params.toString()}`, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (reset) {
                    container.innerHTML = data.html;
                } else {
                    container.insertAdjacentHTML('beforeend', data.html);
                }

                hasMore = data.hasMore;
                if (hasMore) {
                    // Repoint the sentinel anchor at the next page and keep it visible.
                    if (sentinel && data.nextPageUrl) {
                        sentinel.href = data.nextPageUrl;
                    }
                    if (sentinelWrap) sentinelWrap.style.display = '';
                    endOfResults.style.display = 'none';
                } else {
                    if (sentinelWrap) sentinelWrap.style.display = 'none';
                    endOfResults.style.display = 'block';
                }

                page++;
                loading = false;
                loadingSpinner.style.display = 'none';
                container.setAttribute('aria-busy', 'false');
            })
            .catch(error => {
                console.error('Error loading threads:', error);
                loading = false;
                loadingSpinner.style.display = 'none';
                container.setAttribute('aria-busy', 'false');
            });
    }

    // Filter Event Listeners
    document.getElementById('filter-keyword').addEventListener('input', debounce(function (e) {
        filters.keyword = e.target.value;
        fetchThreads(true);
    }, 1000));

    document.getElementById('filter-author').addEventListener('input', debounce(function (e) {
        filters.author = e.target.value;
        fetchThreads(true);
    }, 1000));

    // Quick Dates
    document.getElementById('filter-quick-date').addEventListener('change', function (e) {
        const val = e.target.value;
        const now = new Date();
        const year = now.getFullYear();

        filters.date_start = '';
        filters.date_end = '';

        if (val === 'this_year') {
            filters.date_start = `${year}-01-01`;
            filters.date_end = `${year}-12-31`;
        } else if (val === 'last_year') {
            filters.date_start = `${year - 1}-01-01`;
            filters.date_end = `${year - 1}-12-31`;
        } else if (val.startsWith('month_')) {
            const month = parseInt(val.split('_')[1], 10);
            // Calculate start and end of month for current year
            const lastDay = new Date(year, month, 0).getDate(); // month is 1-indexed for this calculation
            filters.date_start = `${year}-${String(month).padStart(2, '0')}-01`;
            filters.date_end = `${year}-${String(month).padStart(2, '0')}-${lastDay}`;
        }

        // Update date picker input visually
        $('#filter-date-start').val(filters.date_start);
        $('#filter-date-end').val(filters.date_end);

        fetchThreads(true);
    });

    function clearInputs() {
        document.getElementById('filter-keyword').value = '';
        document.getElementById('filter-author').value = '';
        $('#filter-date-start').val('');
        $('#filter-date-end').val('');
        document.getElementById('filter-quick-date').value = '';
    }

    function clearFilters() {
        filters.keyword = '';
        filters.author = '';
        filters.date_start = '';
        filters.date_end = '';
    }

    // Reset Button
    document.getElementById('btn-reset-filters').addEventListener('click', function () {
        clearInputs();
        clearFilters();
        // Keep current sort
        fetchThreads(true);
    });

    // Sort Controls
    document.querySelectorAll('.sort-controls button').forEach(btn => {
        btn.addEventListener('click', function () {
            document.querySelectorAll('.sort-controls button').forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            clearInputs();
            clearFilters();

            filters.sort = this.dataset.sort;
            fetchThreads(true);
        });
    });

    // Infinite Scroll — the sentinel is the server-rendered rel="next" anchor.
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
            fetchThreads();
        }
    }, { rootMargin: '200px' });

    if (sentinel) {
        // Progressive enhancement: intercept the anchor so JS users load the
        // next batch in place instead of navigating to the page-N URL.
        sentinel.addEventListener('click', function (e) {
            e.preventDefault();
            fetchThreads();
        });
        observer.observe(sentinel);
    }
});
